




























































import { Component, Vue } from 'vue-property-decorator'
import DxFileManager from 'devextreme-vue/file-manager'
import CustomFileSystemProvider from 'devextreme/file_management/custom_provider'
import FileManagementService from '@/services/file-management-service'
import { Message } from 'element-ui'
import UserManagerService from '@/services/data/user_manager'

interface FileSystemItem {
  name: string
  isDirectory: boolean
  size?: number
  key?: string
  pathKeys?: string[]
  thumbnail?: string
  relativeName?: string
  parentPath?: string
}

interface APIFileItem {
  name: string
  isDirectory: boolean
  size?: number
  items?: APIFileItem[]
  error?: boolean
}

interface PreviewState {
  visible: boolean
  type: null | 'pdf' | 'excel' | 'image' | 'text' | 'archive' | 'unsupported'
  fileName: string
  excelRows: {cells: {idx: number, value: any}[], idx:number}[]
  imageSrc: string
  textContent: string
  pdfSrc: string
}

@Component({
  name: 'FileManager',
  components: { DxFileManager }
})
export default class extends Vue {
  fileSystemProvider: any = null
  fullFileTree: APIFileItem | null = null

  preview: PreviewState = {
    visible: false,
    type: null,
    fileName: '',
    excelRows: [],
    imageSrc: '',
    textContent: '',
    pdfSrc: '',
  }

  get userHasAnyFileAccess(): boolean {
    const access = this.userService.current_user?.storage_access
    return access === 'read_only' || access === 'read_and_edit'
  }

  get permissions() {
    if (this.userService.current_user.storage_access === 'read_only') {
      return {
        create: false,
        copy: false,
        move: false,
        delete: false,
        rename: false,
        download: true,
        upload: false
      }
    } else if (this.userService.current_user.storage_access === 'read_and_edit') {
      return {
        create: true,
        copy: true,
        move: true,
        delete: true,
        rename: true,
        download: true,
        upload: true
      }
    } else {
      return {
        create: false,
        copy: false,
        move: false,
        delete: false,
        rename: false,
        download: false,
        upload: false
      }
    }
  }

  itemViewConfig = {
    mode: 'details',
    details: {
      columns: [
        {
          dataField: 'thumbnail',
          caption: '',
          width: 50,
          alignment: 'center'
        },
        {
          dataField: 'name',
          caption: 'Имя файла',
          alignment: 'left'
        },
      ]
    }
  }

  public userService = UserManagerService

  async mounted() {
    await this.loadFullFileTree()
    this.initializeFileSystemProvider()
  }

  async loadFullFileTree() {
    try {
      const res = await FileManagementService.getFileTree('/')
      if (!res || res.error) throw new Error('Ошибка загрузки дерева файлов')
      this.fullFileTree = res
    } catch (e) {
      Message.error('Не удалось загрузить дерево файлов')
    }
  }

  findItemsByPath(path: string): APIFileItem[] {
    if (!this.fullFileTree) return []
    if (path === '/' || path === '') return this.fullFileTree.items || []

    const pathParts = path.split('/').filter(Boolean)
    let currentItems = this.fullFileTree.items || []

    for (const part of pathParts) {
      const foundItem = currentItems.find((item) => item.name === part && item.isDirectory)
      if (!foundItem) {
        console.warn('[FileManager] Папка не найдена:', part)
        return []
      }
      currentItems = foundItem.items || []
    }
    return currentItems
  }

  findParentByPath(path: string): APIFileItem | null {
    if (!this.fullFileTree) return null
    if (path === '/' || path === '') return null

    const pathParts = path.split('/').filter(Boolean)
    if (pathParts.length === 0) return this.fullFileTree

    let currentItem = this.fullFileTree
    for (let i = 0; i < pathParts.length - 1; i++) {
      const part = pathParts[i]
      const items = currentItem.items || []
      const foundItem = items.find((item) => item.name === part && item.isDirectory)
      if (!foundItem) {
        console.warn('[FileManager] Родитель не найден:', part)
        return null
      }
      currentItem = foundItem
    }
    return currentItem
  }

  findItemByPath(path: string): APIFileItem | null {
    if (!this.fullFileTree) return null
    if (path === '/' || path === '') return this.fullFileTree

    const pathParts = path.split('/').filter(Boolean)
    let currentItem = this.fullFileTree

    for (const part of pathParts) {
      const items = currentItem.items || []
      const foundItem = items.find((item) => item.name === part)
      if (!foundItem) {
        console.warn('[FileManager] Элемент не найден:', part)
        return null
      }
      currentItem = foundItem
    }
    return currentItem
  }

  addFolderToCache(parentPath: string, folderName: string) {
    if (!this.fullFileTree) return

    if (parentPath === '/' || parentPath === '' || parentPath === './') {
      if (!this.fullFileTree.items) this.fullFileTree.items = []
      if (!this.fullFileTree.items.some(item => item.name === folderName && item.isDirectory)) {
        this.fullFileTree.items.push({
          name: folderName,
          isDirectory: true,
          items: [],
          error: false,
        })
      }
      return
    }

    const parent = this.findParentByPath(parentPath + '/' + folderName)
    if (parent) {
      if (!parent.items) parent.items = []
      if (!parent.items.some(item => item.name === folderName && item.isDirectory)) {
        parent.items.push({
          name: folderName,
          isDirectory: true,
          items: [],
          error: false,
        })
      }
    }
  }

  updateItemNameInCache(path: string, newName: string): boolean {
    if (!this.fullFileTree) return false
    if (path === '/' || path === '') return false

    const pathParts = path.split('/').filter(Boolean)
    const oldName = pathParts[pathParts.length - 1]

    if (pathParts.length === 1) {
      const item = (this.fullFileTree.items || []).find((i) => i.name === oldName)
      if (item) {
        item.name = newName
        return true
      }
      return false
    }

    const parent = this.findParentByPath(path)
    if (parent && parent.items) {
      const item = parent.items.find((i) => i.name === oldName)
      if (item) {
        item.name = newName
        return true
      }
    }
    return false
  }

  removeFromCache(path: string): boolean {
    if (!this.fullFileTree) return false
    if (path === '/' || path === '') return false

    const pathParts = path.split('/').filter(Boolean)
    const itemName = pathParts[pathParts.length - 1]

    if (pathParts.length === 1) {
      const index = (this.fullFileTree.items || []).findIndex((item) => item.name === itemName)
      if (index !== -1) {
        this.fullFileTree.items?.splice(index, 1)
        return true
      }
      return false
    }

    const parent = this.findParentByPath(path)
    if (parent && parent.items) {
      const index = parent.items.findIndex((item) => item.name === itemName)
      if (index !== -1) {
        parent.items.splice(index, 1)
        return true
      }
    }
    return false
  }

  getIconByType(fileName: string): string {
    const ext = fileName.split('.').pop()?.toLowerCase()
    try {
      switch (ext) {
        case 'pdf':
          return require('@/assets/fileicons/pdf.png')
        case 'doc':
        case 'docx':
          return require('@/assets/fileicons/doc.png')
        case 'xls':
        case 'xlsx':
          return require('@/assets/fileicons/xls.png')
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'gif':
        case 'svg':
          return require('@/assets/fileicons/png.png')
        case 'txt':
          return require('@/assets/fileicons/txt.png')
        case '7z':
        case 'rar':
        case 'tar':
        case 'zip':
          return require('@/assets/fileicons/zip.png')
        case 'ppt':
        case 'pptx':
        case 'pps':
          return require('@/assets/fileicons/ppt.png')
        case 'rtf':
          return require('@/assets/fileicons/rtf.png')
        default:
          return require('@/assets/fileicons/file.png')
      }
    } catch (e) {
      console.warn('[FileManager] Не найдена иконка для расширения:', ext, e)
      return require('@/assets/fileicons/file.png')
    }
  }

  refreshFileManager() {
    if (this.$refs.fileManager) {
      try {
        const fileManager = (this.$refs.fileManager as any)
        
        if (fileManager.refresh) {
          fileManager.refresh()
        } else if (fileManager.instance && fileManager.instance.refresh) {
          fileManager.instance.refresh()
        }
      } catch (e) {
        console.warn('[FileManager] Не удалось обновить менеджер:', e)
      }
    }
  }

  initializeFileSystemProvider() {
    this.fileSystemProvider = new CustomFileSystemProvider({
      getItems: async (parentDirectory: FileSystemItem | null) => {
        try {
          const parentPath = !parentDirectory ? '/' : (parentDirectory.key || '/')
          const items = this.findItemsByPath(parentPath)
          return items.map((item: APIFileItem) => {
            const itemPath = parentPath === '/' ? `/${item.name}` : `${parentPath}/${item.name}`
            const hasSubDirectories = item.isDirectory && 
              item.items && 
              item.items.length > 0 &&
              item.items.some(subItem => subItem.isDirectory)
            
            return {
              name: item.name,
              isDirectory: item.isDirectory,
              thumbnail: !item.isDirectory ? this.getIconByType(item.name) : undefined,
              key: itemPath,
              pathKeys: this.getPathKeys(itemPath),
              hasSubDirectories: hasSubDirectories,
            }
          })
        } catch (e) {
          console.error('[FileManager] Ошибка при получении элементов:', e)
          Message.error('Не удалось загрузить файлы')
          return []
        }
      },

      renameItem: async (item: FileSystemItem, newName: string) => {
        try {
          console.log('Переименование элемента:', item, 'в', newName)
          const rawKey = item.key || ''
          const itemPath = rawKey.startsWith('/') ? rawKey.slice(1) : rawKey
          const result = await FileManagementService.renameItem(itemPath, newName)
          console.log('Результат переименования:', result)
          if (!result.success) throw new Error(result.message)

          this.updateItemNameInCache(itemPath, newName)

          Message.success(`Файл переименован: ${newName}`)

          this.$nextTick(() => {
            this.refreshFileManager()
          })
          return true
        } catch (e) {
          console.error('[FileManager] Ошибка при переименовании:', e)
          Message.error('Не удалось переименовать файл')
          return false
        }
      },

      deleteItem: async (item: FileSystemItem) => {
        try {
          const rawKey = item.key || ''
          const itemPath = rawKey.startsWith('/') ? rawKey.slice(1) : rawKey

          if (item.isDirectory) {
            const result = await FileManagementService.deleteFolder(itemPath)
            if (!result.success) throw new Error(result.message)
            this.removeFromCache(itemPath)
            Message.success(`Папка удалена: ${item.name}`)
          } else {
            const result = await FileManagementService.deleteFile(itemPath)
            if (!result.success) throw new Error(result.message)
            this.removeFromCache(itemPath)
            Message.success(`Файл удален: ${item.name}`)
          }
          
          this.$nextTick(() => {
            this.refreshFileManager()
          })
          
          return true
        } catch (e) {
          console.error('[FileManager] Ошибка при удалении:', e)
          Message.error(`Не удалось удалить элемент: ${(e as Error).message}`)
          return false
        }
      },

      createDirectory: async (parentDirectory: FileSystemItem | null, name: string) => {
        try {
          const rawKey = parentDirectory?.key || ''
          const cleanKey = rawKey.startsWith('/') ? rawKey.slice(1) : rawKey
          const parentPath = cleanKey ? cleanKey + '/' : ''
          const items = this.findItemsByPath(parentPath.slice(0, -1) || '/')
          const existingFolder = items.find((item: APIFileItem) => 
            item.name === name && item.isDirectory
          )

          if (existingFolder) {
            Message.warning(`Папка "${name}" уже существует`)
            return false
          }

          const result = await FileManagementService.createFolder({
            create_path: parentPath,
            folder_name: name
          })

          if (!result.success) throw new Error(result.message)
          this.addFolderToCache(parentPath, name)
          Message.success(`Папка создана: ${name}`)
          
          this.$nextTick(() => {
            this.refreshFileManager()
          })
          
          return true
        } catch (e) {
          console.error('[FileManager] Ошибка при создании папки:', e)
          Message.error(`Не удалось создать папку: ${(e as Error).message}`)
          return false
        }
      },

      uploadFileChunk: async (fileData: any, uploadInfo: any, destinationDirectory: FileSystemItem | null) => {
  try {
    if (uploadInfo && uploadInfo.chunkIndex > 0) return true
    
    const rawKey = destinationDirectory?.key || ''
    const cleanKey = rawKey.startsWith('/') ? rawKey.slice(1) : rawKey
    const destPath = cleanKey ? cleanKey : '.'
    const fullPath = destPath === '.' ? fileData.name : destPath + '/' + fileData.name
    const parentPath = destPath === '.' ? '/' : '/' + destPath
    const parentItems = this.findItemsByPath(parentPath)

    const existingFile = parentItems.find((item: APIFileItem) =>
      item.name === fileData.name && !item.isDirectory
    )

    if (existingFile) {
      const confirmed = await new Promise<boolean>((resolve) => {
        this.$confirm(
          `Файл "${fileData.name}" уже существует в папке "${parentPath || '/'}".\n\nЖелаете заменить?`,
          'Файл уже существует',
          {
            confirmButtonText: 'Заменить',
            cancelButtonText: 'Отменить',
            type: 'warning',
            roundButton: true,
          }
        )
          .then(() => resolve(true))
          .catch(() => resolve(false))
      })

      if (!confirmed) {
        Message.info('Загрузка отменена')
        return false
      }

      await FileManagementService.deleteFile(fullPath)
      this.removeFromCache(fullPath)
    }

    const result = await FileManagementService.createFile(fileData, destPath)
    if (!result.success) throw new Error(result.message)

    const cached = parentItems.find((item: APIFileItem) =>
      item.name === fileData.name && !item.isDirectory
    )

    if (!cached) {
      this.addFileToCache(parentPath, fileData.name, fileData.size)
    }

    Message.success(`Файл загружен: ${fileData.name}`)

    this.$nextTick(() => {
      this.refreshFileManager()
    })

    return true
  } catch (e) {
    console.error('[FileManager] Ошибка при загрузке файла:', e)
    Message.error(`Не удалось загрузить файл: ${(e as Error).message}`)
    return false
  }
},


      abortFileUpload: async (fileData: any, uploadInfo: any, destinationDirectory: FileSystemItem) => {
        try {
          const rawKey = destinationDirectory?.key || ''
          const cleanKey = rawKey.startsWith('/') ? rawKey.slice(1) : rawKey
          const destPath = cleanKey ? cleanKey : '.'
          const fullPath = destPath === '.' ? fileData.name : destPath + '/' + fileData.name
          
          try {
            await FileManagementService.deleteFile(fullPath)
          } catch (e) {
            console.warn('[FileManager] Не удалось удалить незаконченный upload:', e)
          }
          
          return true
        } catch (e) {
          console.error('[FileManager] Ошибка при отмене загрузки:', e)
          return false
        }
      },

      downloadItems: async (items: FileSystemItem[]) => {
        try {
          for (const item of items) {
            try {
              const rawKey = item.key || ''
              const itemPath = rawKey.startsWith('/') ? rawKey.slice(1) : rawKey
              await FileManagementService.downloadFile(itemPath)
              Message.success(`Файл ${item.name} загружен`)
            } catch (itemError) {
              console.error('[FileManager] Ошибка при скачивании файла:', item.name, itemError)
              Message.error(`Ошибка при скачивании ${item.name}`)
            }
          }
        } catch (e) {
          console.error('[FileManager] Ошибка при скачивании:', e)
          Message.error('Ошибка при скачивании файлов')
        }
      },

      moveItem: async (item: FileSystemItem, destinationDirectory: FileSystemItem) => {
        try {
          let target_path = item.relativeName || ''
          let dest_path = destinationDirectory.relativeName ? destinationDirectory.relativeName + '/' + item.name : item.name

          const currentItem = this.findParentByPath(target_path + '/' + '1')

          await FileManagementService.cpMoveItem(target_path, dest_path, true)

          if (item.isDirectory) {
            this.moveFolderInCache(destinationDirectory.relativeName + '/', item.name, currentItem)
          } else {
            this.addFileToCache(destinationDirectory.relativeName + '/', item.name)
          }
          this.removeFromCache(target_path)
          Message.success(`Файл ${item.name} перемещён в ${destinationDirectory.relativeName + '/'}`)
        } catch (e) {
          console.error('[FileManager] Ошибка при перемещении:', e)
          Message.error('Ошибка при перемещении файла')
        }
      },

      copyItem: async (item: FileSystemItem, destinationDirectory: FileSystemItem) => {
        try {
          let newItemName = item.name
          let target_path = item.parentPath || ''
          let dest_path = destinationDirectory.relativeName ? destinationDirectory.relativeName : ''

          const currentItem = this.findParentByPath(item.relativeName + '/' + '1')
          const parent = this.findParentByPath(destinationDirectory.relativeName + '/' + '1')
          
          while (parent?.items?.some(item => item.name === newItemName)) {
            newItemName = this.addCopySuffix(newItemName)
          }

          await FileManagementService.cpMoveItem(
            target_path ? target_path + '/' + item.name : item.name,
            dest_path ? dest_path + '/' + newItemName : newItemName,
            false
          )

          if (item.isDirectory) {
            this.moveFolderInCache(destinationDirectory.relativeName + '/', newItemName, currentItem)
          } else {
            this.addFileToCache(destinationDirectory.relativeName + '/', newItemName)
          }
          
          Message.success(`Файл ${item.name} скопирован в ${destinationDirectory.relativeName + '/'}`)
        } catch (e) {
          console.error('[FileManager] Ошибка при копировании:', e)
          Message.error('Ошибка при копировании файла')
        }
      }
    })
  }

  addCopySuffix(fileName: string): string {
    const dotIndex = fileName.lastIndexOf(".")
    if (dotIndex === -1) {
      return fileName + "_copy"
    }
    const name = fileName.substring(0, dotIndex)
    const ext = fileName.substring(dotIndex)
    return `${name}_copy${ext}`
  }

  moveFolderInCache(parentPath: string, folderName: string, currentFolder: APIFileItem | null) {
    if (!this.fullFileTree) return
    if (!currentFolder) return

    if (parentPath === '/' || parentPath === '' || parentPath === './') {
      if (!this.fullFileTree.items) this.fullFileTree.items = []
      if (!this.fullFileTree.items.some(item => item.name === folderName && item.isDirectory)) {
        this.fullFileTree.items.push({
          name: folderName,
          isDirectory: true,
          items: currentFolder.items ? [...currentFolder.items] : [],
          error: false,
        })
      }
      return
    }

    const parent = this.findParentByPath(parentPath + '/' + folderName)
    if (parent) {
      if (!parent.items) parent.items = []
      if (!parent.items.some(item => item.name === folderName && item.isDirectory)) {
        parent.items.push({
          name: folderName,
          isDirectory: true,
          items: currentFolder.items ? [...currentFolder.items] : [],
          error: false,
        })
      }
    }
  }

  moveFileInCache(parentPath: string, fileName: string, currentFile: APIFileItem | null) {
    if (!this.fullFileTree) return
    if (!currentFile) return

    if (parentPath === '/' || parentPath === '' || parentPath === './') {
      if (!this.fullFileTree.items) this.fullFileTree.items = []
      if (!this.fullFileTree.items.some(item => item.name === fileName && !item.isDirectory)) {
        this.fullFileTree.items.push({
          name: fileName,
          isDirectory: false,
          size: currentFile.size,
          error: false,
        })
      }
      return
    }

    const parent = this.findParentByPath(parentPath + '/' + fileName)
    if (parent) {
      if (!parent.items) parent.items = []
      if (!parent.items.some(item => item.name === fileName && !item.isDirectory)) {
        parent.items.push({
          name: fileName,
          isDirectory: false,
          size: currentFile.size,
          error: false,
        })
      }
    }
  }

  addFileToCache(parentPath: string, fileName: string, fileSize: number = 0) {
    if (!this.fullFileTree) return

    if (parentPath === '/' || parentPath === '' || parentPath === './') {
      if (!this.fullFileTree.items) this.fullFileTree.items = []
      if (!this.fullFileTree.items.some(item => item.name === fileName && !item.isDirectory)) {
        this.fullFileTree.items.push({
          name: fileName,
          isDirectory: false,
          size: fileSize,
          error: false,
        })
      }
      return
    }

    const parent = this.findParentByPath(parentPath + '/' + fileName)
    if (parent) {
      if (!parent.items) parent.items = []
      if (!parent.items.some(item => item.name === fileName && !item.isDirectory)) {
        parent.items.push({
          name: fileName,
          isDirectory: false,
          size: fileSize,
          error: false,
        })
      }
    }
  }

  getPathKeys(path: string): string[] {
    return path.split('/').filter(Boolean)
  }

  blobToArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result as ArrayBuffer)
      reader.onerror = reject
      reader.readAsArrayBuffer(blob)
    })
  }

  blobToText(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result as string)
      reader.onerror = reject
      reader.readAsText(blob)
    })
  }

  async parseZipArchive(fileBlob: Blob): Promise<string> {
    try {
      const arrayBuffer = await this.blobToArrayBuffer(fileBlob)
      const view = new DataView(arrayBuffer)
      const uint8Array = new Uint8Array(arrayBuffer)

      let contents = 'Содержимое архива:\n\n'
      let fileCount = 0
      let folderCount = 0
      let totalSize = 0

      let endOfCentralDirOffset = -1
      
      for (let i = arrayBuffer.byteLength - 22; i >= 0; i--) {
        if (view.getUint32(i, true) === 0x06054b50) {
          endOfCentralDirOffset = i
          break
        }
      }

      if (endOfCentralDirOffset === -1) {
        throw new Error('Невалидный ZIP файл')
      }

      const centralDirOffset = view.getUint32(endOfCentralDirOffset + 16, true)
      let offset = centralDirOffset

      while (offset < endOfCentralDirOffset) {
        const signature = view.getUint32(offset, true)
        
        if (signature === 0x02014b50) {
          offset += 4
          offset += 2
          offset += 2
          offset += 2
          offset += 2
          offset += 2
          offset += 2
          offset += 4
          offset += 4
          const uncompressedSize = view.getUint32(offset, true)
          offset += 4
          
          const filenameLength = view.getUint16(offset, true)
          offset += 2
          
          const extraFieldLength = view.getUint16(offset, true)
          offset += 2
          
          const fileCommentLength = view.getUint16(offset, true)
          offset += 2
          
          offset += 2
          offset += 2
          offset += 4
          offset += 4
          
          const filenameBytes = uint8Array.slice(offset, offset + filenameLength)
          const filename = new TextDecoder().decode(filenameBytes)
          offset += filenameLength
          
          offset += extraFieldLength + fileCommentLength
          
          if (filename) {
            const isDir = filename.endsWith('/')
            if (isDir) {
              folderCount++
              contents += '📁 ' + filename + '\n'
            } else {
              fileCount++
              totalSize += uncompressedSize
              const sizeKb = (uncompressedSize / 1024).toFixed(2)
              contents += '📄 ' + filename + ' (' + sizeKb + ' KB)\n'
            }
          }
        } else {
          break
        }
      }

      contents += '\n---\n'
      contents += 'Всего файлов: ' + fileCount + '\n'
      contents += 'Всего папок: ' + folderCount + '\n'
      contents += 'Размер: ' + (totalSize / 1024).toFixed(2) + ' KB\n'

      return contents
    } catch (e) {
      console.error('[FileManager] Ошибка при чтении ZIP:', e)
      throw e
    }
  }

  async previewFile(file: any) {
    try {
      const fileName = file.dataItem.name
      const ext = fileName.split('.').pop()?.toLowerCase() || ''
      this.preview.fileName = fileName
      this.preview.type = null
      this.preview.visible = true

      const filePath = (file.dataItem.key || '').replace(/^\//, '')
      const fileBlob = await FileManagementService.downloadFileBlob(filePath)

      if (!fileBlob) throw new Error('Не удалось получить файл')

      // Предпросмотр PDF
      if (['pdf'].includes(ext)) {
        this.preview.type = 'pdf'
        this.preview.pdfSrc = URL.createObjectURL(fileBlob)
        return
      }

      if (['xls', 'xlsx'].includes(ext)) {
        this.preview.type = 'excel'
        try {
          const ExcelJS = await import('exceljs')
          const wb = new ExcelJS.Workbook()
          const buf = await this.blobToArrayBuffer(fileBlob)
          await wb.xlsx.load(buf)
          const ws = wb.worksheets[0]
          
          if (!ws) {
            this.preview.type = 'unsupported'
            Message.error('Excel файл пуст или повреждён')
            return
          }

          const excelRows: {cells: {idx: number, value: any}[], idx:number}[] = []
          ws.eachRow((row: any, rowNumber: number) => {
            const cells: {idx: number, value: any}[] = []
            if (row.values && Array.isArray(row.values)) {
              row.values.forEach((value: any, cellIdx: number) => {
                if (value !== null && value !== undefined && cellIdx > 0) {
                  cells.push({ idx: cellIdx - 1, value: value })
                }
              })
            }
            if (cells.length > 0) {
              excelRows.push({ idx: rowNumber, cells: cells })
            }
          })
          
          this.preview.excelRows = excelRows
          return
        } catch (excelErr) {
          console.error('[FileManager] Ошибка при чтении Excel:', excelErr)
          this.preview.type = 'unsupported'
          Message.error('Ошибка при чтении Excel файла')
          return
        }
      }

      if (['zip'].includes(ext)) {
        this.preview.type = 'archive'
        try {
          this.preview.textContent = await this.parseZipArchive(fileBlob)
          return
        } catch (e) {
          console.error('[FileManager] Ошибка при чтении ZIP:', e)
          this.preview.type = 'unsupported'
          Message.error('Не удалось открыть ZIP архив')
          return
        }
      }

      if (['png', 'jpg', 'jpeg', 'gif', 'svg'].includes(ext)) {
        this.preview.type = 'image'
        this.preview.imageSrc = URL.createObjectURL(fileBlob)
        return
      }

      if (['txt', 'csv', 'json', 'log', 'md'].includes(ext)) {
        this.preview.type = 'text'
        this.preview.textContent = await this.blobToText(fileBlob)
        return
      }
      this.preview.type = 'unsupported'
    } catch (e) {
      console.error('[FileManager] Ошибка предпросмотра файла:', e)
      this.preview.type = 'unsupported'
      Message.error('Ошибка предпросмотра файла: ' + (e as Error).message)
    }
  }

  async onFileOpen(e: any) {
    try {
      const file = e.file
      if (file.dataItem.isDirectory) {
        return
      }

      await this.previewFile(file)
    } catch (e) {
      console.error('[FileManager] Ошибка при открытии файла:', e)
      Message.error('Ошибка при открытии файла')
    }
  }

  onContextMenuClick(e: any) {
    console.log('[FileManager] Контекстное меню:', e)
  }
}
